export const isAmateur = () => process.env.VUE_APP_API_URL === 'https://api.artificial-models.com';